<template>
    <button
        class="a-compass-button compass-button"
        :aria-label="ariaLabel"
        @click="handleClick"
    >
        <svg-icon
            v-if="localValue"
            original
            name="icons/compass-off"
            :style="{'transform': 'rotate(' + rotate + 'deg)'}"
            class="compass-button__icon"
        />
        <svg-icon
            v-else
            original
            name="icons/compass-active"
            class="compass-button__icon"
            :style="{'transform': 'rotate(' + rotate + 'deg)'}"
        />
    </button>
</template>

<script>
export default {
    name: 'ACompassButton',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        ariaLabel: {
            type: String,
            default: 'Compass button'
        },
        rotate: {
            type: Number,
            default: 0
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    },
    methods: {
        handleClick() {
            if (window.DeviceOrientationEvent) this.localValue = !this.localValue // we check if the device supports the necessary events
        }
    }
}
</script>

<style lang="scss">
@import "a-compass-button.scss";
</style>
